import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarProposalImpactSectionDto } from "../dto/solar-proposal-impact.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * The Solar Proposal environmental impact read. Like the other section reads,
 * it loads and fails apart from the header read, so its errors stay inside
 * the section.
 */
export default function useSolarProposalImpact(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalImpactSectionDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.impact(proposalId ?? ``),
    queryFn: () => solarProposalService.getImpact(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarRead,
  })
}
